// This icon file is generated automatically.
var PStepBackwardOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M3.43 6.26l5.99 4.7c.22.18.55.03.55-.26V1.3a.34.34 0 00-.55-.27l-5.99 4.7a.34.34 0 000 .53m-.27 5.24h-1a.12.12 0 01-.13-.13V.63c0-.07.06-.13.13-.13h1c.07 0 .12.06.12.13v10.74c0 .07-.05.13-.12.13", "fill-rule": "nonzero" } }] }, "name": "p-step-backward", "theme": "outlined" };
export default PStepBackwardOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PStepBackwardOutlined.js
// module id = 3652
// module chunks = 0